import React from "react";
import { addToQueue } from '~/redux/uservideo/helpers'

class ThankYou extends React.Component {
  constructor(props) {
    super(props)
    this.state = {addedToQueue: false}
  }

  pastTense(s){
    const str = s.toLowerCase()
    return str === 'rent' ? `${str}ed`: `${str}d`
  }

  handleWatchClick() {
    addToQueue(this.props.plan.videoID, 'VIDEO', (res) => {
      this.setState({addedToQueue: true});
    });
  }

  renderWatchButton() {
    if(this.props.content.gist.contentType === 'EPISODE' || this.props.content.gist.contentType === 'VIDEO'){
      if(this.state.addedToQueue){
        return <a className="overlay-button added-to-watchlist">Added to Watchlist</a>
      } else {
        return <a onClick={this.handleWatchClick.bind(this)} className="watch-later-button overlay-button">Add to Watchlist</a>
      }
    } else {
      return;
    }
  }

  render() {
    const { content } = this.props
    const showButton = content.gist.scheduleStartDate && content.gist.scheduleStartDate - Date.now() > 0

    return(
      <div className="purchase-thank-you">
        <p className="header">Thank you</p>
        <p className="top"> You have successfully { this.pastTense(this.props.plan.option) } {content.gist.title}</p>
        <p className="bottom"> An email receipt with your {this.props.plan.option} details has been sent to {this.props.user.email}</p>
        <div className="buttons">
          {!showButton && <div className="watch-now-button cta overlay-button" onClick={()=>this.props.fn()}>Watch Now</div>}
          {this.renderWatchButton()}
        </div>
      </div>
    )
  }
}

export default ThankYou;